import store from '@/store'
import firebase from '@/plugins/firebase'
import Auth from '@/services/auth'
import Papeis from '@/services/papeis'
import abilityPlugin from '@/plugins/ability'

export default class FirebaseAuth {

  static onAuthStateChanged() {

    return new Promise((resolve, reject) => {
      firebase.auth().onAuthStateChanged(async user => {
        if (user) {
          if(user.emailVerified) {
            try{
              const auth = new Auth()
              let userData = await auth.getUserByEmail(user.email)
              let validateResult = await auth.validateAccount(userData)
              userData = validateResult

              await FirebaseAuth.setUserData(userData)
            }catch(error){
              console.error(error)
              FirebaseAuth.signOut()
              return reject(error)
            }
          }
        }

        store.commit('app/setLoadingScreen', false)
        return resolve()
      })
    })

  }

  static async setUserData(userData) {
    store.commit('auth/setUser', userData)
    store.commit('auth/setEmpresaPrincipal', userData.empresaPrincipal)
    store.commit('auth/setGrupoPrincipal', userData.grupoPrincipal)
    store.commit('auth/setPrefix', userData.prefix)
    store.commit('auth/setPapel', userData.papel)
    store.commit('setEmpresas', userData.empresas)

    await this.setAcessos(userData.papel)
    return Promise.resolve()
  }

  static async setAcessos(papel)
  {
    let acessos = await new Papeis().getAcessos(papel)
    abilityPlugin.defineAbilities(acessos)
    return Promise.resolve()
  }

  static async signOut() {
    try{
      await new Auth().signOut()
      return Promise.resolve()
    }catch(error){
      console.error(error)
      Promise.reject(erro)
    }
  }

}
